import { Header } from '../header/headers';
/** Returns true if the provided object was created from {@link buildStorage} function. */
export const isStorage = (obj) => !!obj && !!obj['is-storage'];
/** Returns true if this has sufficient properties to stale instead of expire. */
export function canStale(value) {
    const headers = value.data.headers;
    return (Header.ETag in headers ||
        Header.LastModified in headers ||
        Header.XAxiosCacheEtag in headers ||
        Header.XAxiosCacheStaleIfError in headers ||
        Header.XAxiosCacheLastModified in headers);
}
/**
 * Checks if the provided cache is expired. You should also check if the cache
 * {@link canStale}
 */
export function isExpired(value) {
    return value.createdAt + value.ttl <= Date.now();
}
/**
 * Builds a custom storage.
 *
 * **Note**: You can only create an custom storage with this function.
 *
 * @example
 *
 * ```js
 * const myStorage = buildStorage({
 *   find: () => {...},
 *   set: () => {...},
 *   remove: () => {...}
 * });
 *
 * const axios = setupCache(axios, { storage: myStorage });
 * ```
 */
export function buildStorage({ set, find, remove }) {
    return {
        //@ts-expect-error - we don't want to expose thi
        ['is-storage']: 1,
        set,
        remove,
        get: async (key, config) => {
            const value = await find(key, config);
            if (!value) {
                return { state: 'empty' };
            }
            if (
            // Not cached or fresh value
            value.state !== 'cached' ||
                !isExpired(value)) {
                return value;
            }
            if (canStale(value)) {
                const stale = {
                    state: 'stale',
                    createdAt: value.createdAt,
                    data: value.data
                };
                await set(key, stale, config);
                return stale;
            }
            await remove(key, config);
            return { state: 'empty' };
        }
    };
}
